<template>
  <div>
    <div class="h-scroll h100-80">
      <div class="h-toolbarBg">
        <ejs-toolbar ref="toolbarForReport">
          <e-items>
            <e-item prefixIcon='icon hero-icon hero-icon-indicator-overview' :tooltipText='$t("Pm.singleInstanceChartStatistics")' :click="measurementReport" operate='singleQuery'></e-item>
            <e-item prefixIcon='icon hero-icon hero-icon-statistics' :tooltipText='$t("Pm.multiInstanceChartStatistics")' :click="manyReport" operate='manyQuery'></e-item>
          </e-items>
        </ejs-toolbar>
      </div>
    </div>
    <div class="h-pm-dataQuery-tree">
      <ejs-treeview ref='PmNoRealReportLeftTree' :fields='fieldsOfResourceTreeForReport' :nodeSelected='nodeSelectedOfResourceTreeForReport'></ejs-treeview>
    </div>
  </div>
</template>

<script>
import {PmEventBus} from "../../../util/PmEventBus";

export default {
  name: 'PmNoRealReportLeftTree',
  components: {
  },
  data() {
    return {
      fieldsOfResourceTreeForReport: {
        dataSource: [{ children: [] }],
        id: 'id',
        text: 'text',
        child: 'children',
        expanded: 'state',
        tooltip: 'text',
      }
    }
  },
  methods: {

    measurementReport(){
      PmEventBus.$emit('measurementReport');
    },

    manyReport(){
      PmEventBus.$emit('resourceReport');
    },

    initResourseTreeForReport(){
      this.$axios.post(`/lte/ems/pm/noReal/query/buildNoRealTaskResourceTreeForDataQuery.html`).then((response) => {
        this.fieldsOfResourceTreeForReport = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state',
          iconCss: 'iconCls'
        };
      });
    },

    initToolBarEnable(){
      this.$refs.toolbarForReport.enableItems([0, 1], false);
    },

    nodeSelectedOfResourceTreeForReport(node){
      if (node.nodeData.id == 'root') {
        this.$refs.toolbarForReport.enableItems([0, 1], false);
      } else if(node.nodeData.parentID == 'root') {
        this.$refs.toolbarForReport.enableItems([1], true);
        this.$refs.toolbarForReport.enableItems([0], false);
      } else{
        this.$refs.toolbarForReport.enableItems([0], true);
        this.$refs.toolbarForReport.enableItems([1], false);
      }

      PmEventBus.$emit('transferNodeInfoOfResourceTreeSelected',node);
    }
  },
  mounted() {
    this.initResourseTreeForReport();
    this.initToolBarEnable();
  }
};
</script>

<style>

</style>
